<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
html,
body {
  font: normal normal 14px/1.5 "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
  margin: 0;
  padding: 0;
}
h1,
h4 {
  margin: 0;
  font-weight: normal;
}
footer,
header {
  display: block;
}
a {
  color: #333;
  text-decoration: none;
}
img {
  border: 0px;
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.container {
  width: 1260px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue